import { Actions } from '../../interfaces'
import { StockViewDetails } from '@/entities/sales'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { StockViewDetails },
  actions: { [StockViewDetails.name]: actions },
}
